'use client';

import styles from './organization-hosted-events.module.scss';
import { EventCard } from '@goodneighbor/ui';
import useEventsQuery from '@/hooks/api/events/useEventsQuery';
import { EventsResponse } from '@goodneighbor/api/schemas/events/index';
import { useState } from 'react';
import EventSlideOut from '@/components/EventSlideOut';
import { EventWithOrganization } from '@/services/webApi';
import { parseForEventCardProps } from '@/services/event';

type SponsoredEventsSectionProps = {
  organizationId: string;
};

export function SponsoredEventsSection({
  organizationId
}: SponsoredEventsSectionProps) {
  const [selectedEvent, setSelectedEvent] =
    useState<EventWithOrganization | null>(null);
  const { data, isLoading, isError } = useEventsQuery({
    sponsor: organizationId,
    perPage: 6
  });

  if (isLoading) {
    return null;
  }

  if (isError) {
    return (
      <section className={styles.container}>
        <h2 className={styles.title}>Partnered Events</h2>
        <p className={styles.message}>Failed to load partnered events.</p>
      </section>
    );
  }

  const events = (data as EventsResponse)?.data?.events || [];

  if (events.length === 0) {
    return null;
  }

  return (
    <section className={styles.container}>
      <h2 className={styles.title}>Partnered Events</h2>
      <div className={styles.grid}>
        {events.map((event) => (
          <EventCard
            key={event.id}
            {...parseForEventCardProps(
              event,
              event.clientName || event.locationName || ''
            )}
            onClick={() => setSelectedEvent(event as EventWithOrganization)}
            style={{ cursor: 'pointer' }}
          />
        ))}
      </div>
      <EventSlideOut
        isOpen={!!selectedEvent}
        onOpenChange={() => setSelectedEvent(null)}
        event={selectedEvent}
      />
    </section>
  );
}
